export const STREAMING = 'STREAMING';
export const STREAMING_FREE = 'STREAMING_FREE';
export const STREAMING_CONFIGS = [STREAMING_FREE, STREAMING];

export const SPARKLE_COMMUNICATION_ENABLED = 'OPT_IN_HOTMART_COMMUNICATION';
export const SPARKLE_COMMUNICATION_DISABLED = 'OPT_OUT_HOTMART_COMMUNICATION';
export const STREAMING_CAMPAIGN_CANDIDATE = 'STREAMING_SPARKLE_CAMPAIGN';
export const BETA_SALES_DASHBOARD = 'BETA_SALES_DASHBOARD';
export const WEBINAR_LIVE = 'WEBINAR_LIVE';
export const SAME_PRODUCT_CONTENT_DUPLICATION_BETA =
  'SAME_PRODUCT_CONTENT_DUPLICATION_BETA';

export const TEMPLATE = {
  MIDNIGHT: 'MIDNIGHT',
  DEFAULT: 'DEFAULT',
  ONLINE_EVENT: 'ONLINE_EVENT'
};

export const CLUB_DRM_BETA_TESTER = 'CLUB_DRM_BETA_TESTER';

export const ATTACHMENT_UPLOAD_LIMIT = 20;
export const ATTACHMENT_UPLOAD_EXTRA_LIMIT = 70;
